import {
  fetchActiveTickets,
  fetchChannelsByTicketWithoutChannelPerson,
  fetchChannelsByTicket,
  fetchWorkspaceClientByTicket,
  updatePersonalInformation,
  addPhonesClient,
  deletePhoneClient,
  addAddressesClient,
  deleteAddresseClient,
  createClientEmail,
  deleteEmailClient,
  sendWorkspaceMessage,
  updateAddressesClient,
  updatePhonesClient,
  updateEmailClient,
  updateDataCustom,
  searchClients,
  assignClient,
  assignTagToTickets,
  tranferTicketAgent,
  tranferTicketQueues,
  createNewClient,
  saveDefaultManagement,
  addContactClient,
  updateContactClient,
  deleteContactClient,
  ticketHistoryDetail,
  fetchPortfolioDetail,
  typificationsTable,
  getEmailHistory,
} from "@/app/workspace/services";

import { ticketService } from "../../services/TicketService";

import {
  SET_CLIENT,
  SET_TICKETS,
  SET_MESSAGE_HISTORY,
  UPDATE_PERSONAL_INFORMATION,
  SET_CLIENT_CHANNELS,
  SET_HAS_NEXT_TICKET_PAGE,
  ADD_PHONES_CLIENT,
  REMOVE_PHONE_CLIENT,
  ADD_ADDRESSES_CLIENT,
  REMOVE_ADDRESSES_CLIENT,
  REMOVE_EMAIL_CLIENT,
  ADD_EMAIL_CLIENT,
  UPDATE_ADDRESSES_CLIENT,
  UPDATE_PHONES_CLIENT,
  UPDATE_EMAIL_CLIENT,
  UPDATE_DATA_CUSTOM,
  SET_CLIENTS_WITH_SAME_NUMBER_FOUND,
  SET_CLIENTS_FOUND,
  SET_CLEAN_RESULTS,
  SET_CONTACTS_CLIENT,
  UPDATE_CONTACTS_CLIENT,
  DELETE_CONTACTS_CLIENT,
  SET_CALL_FINISH,
  SET_TICKET_DETAIL,
  SET_TICKETS_LIST_PAGE,
  SET_PORTFOLIO_DETAIL,
  SET_TYPIFICATIONS_TABLE_DATA,
  SET_CAPTURE,
  SET_INTERACTIONS_CHANNEL,
  SET_EMAIL_HISTORY,
  SET_EVENT_MESSAGING,
  SET_IS_VISITOR_TYPING,

  RESET_CHUNK,
  SET_CHUNKS,
  SET_CHUNK,
  APPEND_CHUNK,
  SET_CURSORS,
  INSERT_NEW_TICKET,
  REMOVE_TICKET,
  RESET_AFTER_FIRST,
  REBALANCE_ALL_CHUNK_TICKETS,
} from "./mutation-types";
import { debounce } from "lodash";
import { ModeFetchWorkspace } from "@/app/workspace/utils/enums";
import EventBus from "@/app/shared/utils/eventBus";
import { WorkspaceEvent } from "@/app/workspace/domain/events";
import * as Sentry from "@sentry/vue";

function debouncePromise(fn, delay) {
  let timer;
  return (...args) =>
    new Promise((resolve, reject) => {
      clearTimeout(timer);
      timer = setTimeout(async () => {
        try {
          const result = await fn(...args);
          resolve(result);
        } catch (error) {
          reject(error);
        }
      }, delay);
    });
}

/** FUNCIONES PARA MANEJO DE CHUNKS TICKETS WORKSPACE **/

function mergeByIdPreserveOrder(primary, secondary) {
  const seen = new Set();
  const out = [];

  for (const t of primary) {
    if (t && !seen.has(t.id)) {
      seen.add(t.id);
      out.push(t);
    }
  }

  for (const t of secondary) {
    if (t && !seen.has(t.id)) {
      seen.add(t.id);
      out.push(t);
    }
  }

  return out;
}

// function rebuildChunksFromList(list, limit) {
//   const chunks = [];
//   for (let i = 0; i < list.length; i += limit) {
//     chunks.push({ cursor: null, tickets: list.slice(i, i + limit) });
//   }
//   return chunks;
// }
function rebuildChunksFromList(list, limit, prevChunks = []) {
  const chunks = [];
  const prevCursors = (prevChunks || []).map(c => c?.cursor ?? null);

  for (let i = 0; i < list.length; i += limit) {
    const chunkIndex = Math.floor(i / limit);

    // Regla:
    // - chunk 0 siempre cursor null (primera página)
    // - chunk N usa el cursor que ya existía en esa posición (si había)
    const cursor = (chunkIndex === 0) ? null : (prevCursors[chunkIndex] ?? null);

    chunks.push({
      cursor,
      tickets: list.slice(i, i + limit),
    });
  }

  return chunks;
}

async function refreshFirstChunk({ commit, state }, { filters, limit }) {
  console.log("fetchActiveWorkspaceTickets--> refreshFirstChunk");
  const { results, channelsCount } = await fetchActiveTickets({
    ...filters,
    cursor: null,
    limit,
  });
  if (!Array.isArray(results)) return;

  // 1) Aplanar lo que ya tenías cargado
  const existingFlat = (state.chunks || [])
    .flatMap(c => Array.isArray(c.tickets) ? c.tickets : []);

  // 2) Merge: primero manda el backend (orden “verdad”), luego lo existente
  const merged = mergeByIdPreserveOrder(results, existingFlat);

  // 3) Reconstruir chunks completos de forma determinística
  const newChunks = rebuildChunksFromList(merged, limit, state.chunks);

  // 4) Commit de una sola vez (idealmente una mutación)
  commit(SET_CHUNKS, { chunks: newChunks, channelsCount });
}


async function refreshTopChunkPreserveOrder({ commit, state }, { filters, limit }) {
  console.log("fetchActiveWorkspaceTickets--> refreshTopChunkPreserveOrder");
  const { results, channelsCount } = await fetchActiveTickets({ ...filters, cursor: null, limit });
  if (!results) return;

  commit(SET_CHUNK, { cursor: null, tickets: results, channelsCount });

  if (!results.length) return;

  // Eliminar duplicados en los demás chunks
  const firstIds = new Set(results.map(t => t.id));
  state.chunks.forEach((chunk, idx) => {
    if (idx === 0) return;
    chunk.tickets = chunk.tickets.filter(t => !firstIds.has(t.id));
  });

  commit(REBALANCE_ALL_CHUNK_TICKETS, limit);
}

async function refreshChunkByCursor({ commit }, { filters, cursor, limit }) {
  console.log("fetchActiveWorkspaceTickets--> refreshChunkByCursor");
  const { results, channelsCount, nextCursor, prevCursor } = await fetchActiveTickets({ ...filters, cursor, limit });
  if (results) {
    commit(SET_CHUNK, { cursor, tickets: results, channelsCount });
  }
  return { results, nextCursor };
}

function findChunkByTicketId(chunks, ticketId) {
  const idx = chunks.findIndex(c => c.tickets?.some(t => t.id == ticketId));
  console.log(idx, 'refresh mode found chunk index');
  return { idx, chunk: idx >= 0 ? chunks[idx] : null };
}

function pruneInvalidChunks(state) {
  if (!Array.isArray(state.chunks)) return;

  state.chunks = state.chunks.filter((chunk, idx) => {
    if (!chunk) return false;
    if (idx === 0) return true;          // primer chunk permitido
    return !!chunk.cursor;               // los demás DEBEN tener cursor
  });
}

function findLastRealChunk(state) {
  for (let i = state.chunks.length - 1; i >= 0; i--) {
    const c = state.chunks[i];
    if (i === 0 || c?.cursor) {
      return { idx: i, chunk: c };
    }
  }
  return { idx: -1, chunk: null };
}

async function refreshLastChunkAndRecomputeCursor(
  { commit, state },
  { filters, limit }
) {
  console.log("fetchActiveWorkspaceTickets--> refreshLastChunkAndRecomputeCursor");
  const { chunk } = findLastRealChunk(state);
  if (!chunk) return false;

  const { results, nextCursor, prevCursor, channelsCount } =
    await fetchActiveTickets({
      ...filters,
      cursor: chunk.cursor,   //  cursor REAL
      limit,
    });

  if (!Array.isArray(results)) return false;

  // refresca SOLO ese chunk
  commit(SET_CHUNK, {
    cursor: chunk.cursor,
    tickets: results,
    channelsCount,
  });

  //  recalcula cursores globales
  commit(SET_CURSORS, { nextCursor, prevCursor });

  return !!nextCursor;
}

async function loadNextChunkIfExists(
  { commit, state },
  { filters, limit }
) {
  if (!state.nextCursor) return;

  const { nextCursor, prevCursor } = await refreshChunkByCursor(
    { commit },
    {
      filters,
      cursor: state.nextCursor,
      limit,
    }
  );
  commit(SET_CURSORS, { nextCursor, prevCursor });
  console.log({ nextCursor, prevCursor }, 'loadNextChunkIfExists response');
}
/** FIN FUNCIONES PARA MANEJO DE CHUNKS TICKETS WORKSPACE **/

const actions = {
  async fetchWorkspaceClientByTicket({ commit }, { ticketId, preview, refresh = false }) {
    if (!refresh) commit(SET_CLIENT, null);
    const client = await fetchWorkspaceClientByTicket(ticketId, preview);
    commit(SET_CLIENT, client);
  },
  // fetchActiveWorkspaceTickets: debounce(async function ({ commit, state }, { page = 1 } = {}) {
  //   const filters = state.ticketsFilters;
  //   const { tickets, nextPage } = await fetchActiveTickets({ ...filters, page });

  //   commit(SET_HAS_NEXT_TICKET_PAGE, Boolean(nextPage));
  //   commit(SET_TICKETS_LIST_PAGE, page);
  //   commit(SET_TICKETS, page === 1 ? tickets : [...state.tickets, ...tickets]);
  // }, 100),
  fetchActiveWorkspaceTickets: async function (
    { commit, state },
    {
      mode = ModeFetchWorkspace.Initial,
      cursor = null,
      ticketId = null,
      limit = 30,
    } = {}
  ) {
    const filters = state.ticketsFilters;

    console.log(mode, ' ------ refresh tickets ------');

    // ⚡️ Si no hay chunks cargados, siempre forzar Initial
    if (!state.chunks || state.chunks.length === 0) {
      mode = ModeFetchWorkspace.Initial;
      cursor = null;
      ticketId = null;
    }

    const shouldUpdateCursors =
      [ModeFetchWorkspace.Initial, ModeFetchWorkspace.Pagination].includes(mode);

    if ([ModeFetchWorkspace.Initial, ModeFetchWorkspace.Pagination].includes(mode)) {

      if (mode == ModeFetchWorkspace.Initial) {
        commit(RESET_CHUNK);
      }
      const { results, nextCursor, prevCursor, channelsCount } = await fetchActiveTickets({
        ...filters,
        cursor,
        limit,
      });

      if (shouldUpdateCursors) {
        commit(SET_CURSORS, { nextCursor, prevCursor });
      }

      if (mode === ModeFetchWorkspace.Pagination && cursor && results?.length > 0) {
        commit(APPEND_CHUNK, { cursor, tickets: results });
      } else {
        
        // Initial
        commit(SET_CHUNK, { cursor: null, tickets: results, channelsCount });
        EventBus.emit(WorkspaceEvent.RESET_LIST);
      }
    }

    else if (mode === ModeFetchWorkspace.New) {
      // aquí solo refrescas el primer chunk con su helper y rebalancear
      // await refreshFirstChunk({ commit, state }, { filters, limit });

      // refrescar siempre el primer chunk
      await refreshFirstChunk({ commit, state }, { filters, limit });

      // rebalancear (mover tickets entre chunks ya que hay nuevo ticket al inicio)
      commit(REBALANCE_ALL_CHUNK_TICKETS, limit);

      // 3eliminar chunks inválidos (sin cursor)
      pruneInvalidChunks(state);

      if (state.chunks.length === 1) {
        // commit(SET_CURSORS, cursors);
      } else {
        // 4 refrescar el último chunk válido para recalcular nextCursor
        const hasNext = await refreshLastChunkAndRecomputeCursor(
          { commit, state },
          { filters, limit }
        );

        // 5 si hay nextCursor, cargar el siguiente chunk real
        if (hasNext) {
          const previouslyLoadedCursors = new Set(
            state.chunks
              .map((chunk) => chunk?.cursor)
              .filter(Boolean)
          );
          
          const wasNextChunkAlreadyLoaded = hasNext && previouslyLoadedCursors.has(state.nextCursor);

          if (wasNextChunkAlreadyLoaded) {
            console.log("fetchActiveWorkspaceTickets next chunk - new ticket");
            await loadNextChunkIfExists(
              { commit, state },
              { filters, limit }
            );
          }

          // console.log("fetchActiveWorkspaceTickets next chunk - new ticket");
          // await loadNextChunkIfExists({ commit, state }, { filters, limit });
        }
      }
      // // 4 refrescar el último chunk válido para recalcular nextCursor
      // const hasNext = await refreshLastChunkAndRecomputeCursor(
      //   { commit, state },
      //   { filters, limit }
      // );

      // // 5 si hay nextCursor, cargar el siguiente chunk real
      // if (hasNext) {
      //   console.log("fetchActiveWorkspaceTickets next chunk - new ticket");
      //   await loadNextChunkIfExists({ commit, state }, { filters, limit });
      // }
    }

    else if (mode === ModeFetchWorkspace.RefreshByTicket) {
      console.log(ticketId, 'refresh by ticket id');
      console.log(state.chunks, 'before refresh tickets chunks');
      const { idx, chunk } = findChunkByTicketId(state.chunks, ticketId);
      console.log(idx, 'refresh idx');

      // 1 refrescar siempre el primer chunk
      await refreshTopChunkPreserveOrder({ commit, state }, { filters, limit });

      // 2 refrescar el chunk donde estaba el ticket (si existe)
      if (idx !== -1 && chunk) {
        await refreshChunkByCursor({ commit }, { filters, cursor: chunk.cursor, limit });
      }

      // 3 rebalancear todo
      commit(REBALANCE_ALL_CHUNK_TICKETS, limit);
    }

    console.log(state.chunks, 'refresh tickets chunks');
    console.log(state.nextCursor, 'nextCursor chunks');
  },
  async moveTicketAfterUnanchor({ commit, state }, { ticket }) {
    console.log('move unanchor', ' ------ refresh tickets ------');

    const chunks = state.chunks;
    if (!chunks || chunks.length === 0) return;

    const ticketId = ticket.id;
    const filters = state.ticketsFilters;

    // 1. Localizar chunk original
    const { idx, chunk } = findChunkByTicketId(state.chunks, ticketId);
    if (idx === -1 || !chunk) return;

    const removedTicket = JSON.parse(JSON.stringify(ticket));
    removedTicket.anchored = false;

    // 2. Refrescar solo el chunk donde estaba
    await refreshChunkByCursor(
      { commit },
      { filters, cursor: chunk.cursor, limit: chunk.tickets.length }
    );

    // 3. Releer chunks ya actualizados
    const updatedChunks = state.chunks;

    // 4. Aplanar tickets y ELIMINAR toda instancia del ticket primero
    let allTickets = updatedChunks.flatMap(c => c.tickets);
    allTickets = allTickets.filter(t => t.id !== removedTicket.id);

    // Insertarlo solo una vez
    allTickets.push(removedTicket);

    // 5. Orden oficial global
    allTickets.sort((a, b) => {
      if (a.anchored !== b.anchored) return b.anchored - a.anchored;
      const ad = a.last_interaction_date ? new Date(a.last_interaction_date).getTime() : 0;
      const bd = b.last_interaction_date ? new Date(b.last_interaction_date).getTime() : 0;
      if (ad !== bd) return bd - ad;
      return Number(b.id) - Number(a.id);
    });

    // 6. Rebuild chunks sin duplicados
    function rebuildChunks(allTickets, originalChunks) {
      const size = originalChunks[0].tickets.length;     // tamaño por página
      const newChunks = [];
      let pointer = 0;

      // generar solo chunks necesarios según tickets reales
      while (pointer < allTickets.length) {
        newChunks.push({
          cursor: newChunks.length === 0 ? null : originalChunks[newChunks.length]?.cursor || null,
          tickets: allTickets.slice(pointer, pointer + size),
        });
        pointer += size;
      }

      return newChunks;
    }

    const finalChunks = rebuildChunks(allTickets, updatedChunks);

    commit(SET_CHUNKS, { chunks: finalChunks });
    console.log(state.chunks, 'refresh tickets chunks');
  },
  /**
   * Obtener el historial de tickets con sus mensajes.
   * @param {payload} payload Parámetros para la petición.
   * @param {boolean} payload.prevent Prevenir el efecto de cargando.
   */
  async fetchHistoryByTicket({ commit, state }, payload) {
    console.log("fetchHistoryByTicket", payload);
    if (!payload?.prevent) commit(SET_MESSAGE_HISTORY, null);
    const ticketId = payload?.ticket;
    const interactionId = payload?.interaction || null;
    const isWorkspace = payload?.isWorkspace || false;
    if (interactionId) {
      const history = await ticketService.getInteractionMessages(interactionId, isWorkspace);
      console.log(history, "HISTORYYY");
      commit(SET_MESSAGE_HISTORY, history);
      EventBus.emit(WorkspaceEvent.REFRESH_SIDEBAR_UNREAD);
      const ticketsAll = state.chunks ? [].concat(...state.chunks.map(c => c.tickets)) : [];
      const ticketInList = ticketsAll.find((t) => t.id === Number(ticketId));

      if (!ticketInList) return;

      if (history?.messages?.length > 0) {
        const lastMessage = history?.messages.at(-1);

        if (lastMessage && ticketInList?.last_message) {
          ticketInList.last_message.message = lastMessage.message;
          ticketInList.last_message.datetime = lastMessage.created_at;
        }
      }
      ticketInList.unread_messages = 0;
    }
  },
  async saveDefaultManagement({ dispatch }, body) {
    const response = await saveDefaultManagement(body);
    console.log("fetchActiveWorkspaceTickets saveDefaultManagement");
    dispatch("fetchActiveWorkspaceTickets", {
      mode: ModeFetchWorkspace.RefreshByTicket,
      ticketId: body?.ticket,
    });
    return response;
  },
  async sendWorkspaceMessage(_, payload) {
    await sendWorkspaceMessage(payload);
  },
  async fetchChannelsByTicketWithoutChannelPerson({ commit }, ticketId) {
    commit(SET_CLIENT_CHANNELS, []);
    const channels = await fetchChannelsByTicketWithoutChannelPerson(ticketId);
    commit(SET_CLIENT_CHANNELS, channels);
  },
  async fetchChannelsByTicket({ commit }, ticketId) {
    commit(SET_CLIENT_CHANNELS, []);
    const channels = await fetchChannelsByTicket(ticketId);
    commit(SET_CLIENT_CHANNELS, channels);
  },
  async updatePersonalInformation({ commit }, { ticketId, data }) {
    const updatedInformation = await updatePersonalInformation(ticketId, data);
    commit(UPDATE_PERSONAL_INFORMATION, updatedInformation);
  },
  async addAddresseClient({ commit }, { ticketId, addresses }) {
    const dataAddresse = await addAddressesClient(ticketId, addresses);
    commit(ADD_ADDRESSES_CLIENT, dataAddresse);
  },
  async updateAddresseClient({ commit }, { id, addresses }) {
    const dataAddresse = await updateAddressesClient(id, addresses);
    commit(UPDATE_ADDRESSES_CLIENT, dataAddresse);
  },
  async updateEmailClient({ commit }, { emailId, body }) {
    const dataEmail = await updateEmailClient(emailId, body);
    commit(UPDATE_EMAIL_CLIENT, dataEmail);
  },
  async updateDataCustom({ commit }, { clientId, body }) {
    const dataCustom = await updateDataCustom(clientId, body);
    commit(UPDATE_DATA_CUSTOM, [dataCustom]);
  },
  async createClientEmail({ commit }, { ticketId, body }) {
    const dataEmail = await createClientEmail(ticketId, body);
    commit(ADD_EMAIL_CLIENT, dataEmail);
  },
  async addPhonesClient({ commit }, { ticketId, phones }) {
    const dataPhone = await addPhonesClient(ticketId, phones);
    commit(ADD_PHONES_CLIENT, dataPhone);
  },
  async updatePhoneClient({ commit }, { id, phones }) {
    const dataPhone = await updatePhonesClient(id, phones);
    commit(UPDATE_PHONES_CLIENT, dataPhone);
  },
  async deleteAddresseClient({ commit }, addresseId) {
    await deleteAddresseClient(addresseId);
    commit(REMOVE_ADDRESSES_CLIENT, addresseId);
  },
  async deleteEmailClient({ commit }, emailId) {
    await deleteEmailClient(emailId);
    commit(REMOVE_EMAIL_CLIENT, emailId);
  },
  async deletePhoneClient({ commit }, { phoneId, client }) {
    await deletePhoneClient(phoneId, client);
    commit(REMOVE_PHONE_CLIENT, phoneId);
  },
  async addContactClient({ commit }, { ticketId, contact }) {
    const newContact = await addContactClient(ticketId, contact);
    commit(SET_CONTACTS_CLIENT, newContact);
  },
  async updateContactClient({ commit }, { ticketId, contact }) {
    const newContact = await updateContactClient(ticketId, contact);
    commit(UPDATE_CONTACTS_CLIENT, newContact);
  },
  async deleteContactClient({ commit }, { ticketId, contact }) {
    await deleteContactClient(ticketId, contact.id);
    commit(DELETE_CONTACTS_CLIENT, contact.id);
  },
  async searchClientsWithSameNumber({ commit }, searchNumber) {
    if (!searchNumber) {
      commit(SET_CLIENTS_WITH_SAME_NUMBER_FOUND, []);
      return;
    }
    const data = await searchClients(searchNumber);
    commit(SET_CLIENTS_WITH_SAME_NUMBER_FOUND, data.results);
  },
  async searchClients({ commit }, searchText) {
    const data = await searchClients(searchText);
    commit(SET_CLIENTS_FOUND, data.results);
  },
  async assignClient({ dispatch }, body) {
    const data = await assignClient(body);
    console.log("fetchActiveWorkspaceTickets assignClient");
    // actualiza por socket
    // await dispatch("fetchActiveWorkspaceTickets", {
    //   mode: ModeFetchWorkspace.Initial,
    // });
    return data;
  },
  async cleanResultsClient({ commit }) {
    commit(SET_CLEAN_RESULTS, []);
  },
  async tranferTicketAgent({ dispatch }, body) {
    await tranferTicketAgent(body);
    console.log("fetchActiveWorkspaceTickets tranferTicketAgent");
    await dispatch("fetchActiveWorkspaceTickets", {
      mode: ModeFetchWorkspace.RefreshByTicket,
      ticketId: body?.tickets?.[0],
    });
  },
  async tranferTicketQueues({ dispatch }, body) {
    await tranferTicketQueues(body);
    console.log("fetchActiveWorkspaceTickets tranferTicketQueues");
    await dispatch("fetchActiveWorkspaceTickets", {
      mode: ModeFetchWorkspace.RefreshByTicket,
      ticketId: body?.tickets?.[0],
    });
  },
  async assignTagToTickets({ dispatch }, body) {
    await assignTagToTickets(body);
    console.log("fetchActiveWorkspaceTickets assignTagToTickets");
    // actualiza listado por socket
    // await dispatch("fetchActiveWorkspaceTickets", {
    //   mode: ModeFetchWorkspace.Initial,
    // });
  },
  async createNewClient({ dispatch }, body) {
    const data = await createNewClient(body);
    console.log("fetchActiveWorkspaceTickets createNewClient");
    // actualiza listado por socket
    return data;
  },
  callEnded({ commit }, call) {
    commit(SET_CALL_FINISH, call);
  },
  async getTicketHistoryDetail({ commit }, ticketId) {
    const response = await ticketHistoryDetail(ticketId);
    commit(SET_TICKET_DETAIL, response);
  },
  async fetchPortfolioDetail({ commit }, portfolioId) {
    const response = await fetchPortfolioDetail(portfolioId);
    commit(SET_PORTFOLIO_DETAIL, response);
  },
  async fetchTypificationsTableData({ commit }, ticketId) {
    const response = await typificationsTable(ticketId);
    commit(SET_TYPIFICATIONS_TABLE_DATA, response);
  },
  setCaptureTicket({ commit }, data) {
    commit(SET_CAPTURE, data);
  },
  async fetchInteractionsChannels({ commit }, ticketId) {
    const data = await ticketService.getInteractionsChannels(ticketId);
    commit(SET_INTERACTIONS_CHANNEL, data);
  },
  async getEmailHistory({ commit }, emailId) {
    const response = await getEmailHistory(emailId);
    commit(SET_EMAIL_HISTORY, response);
  },
  setEventMessaging({ commit }, data) {
    commit(SET_EVENT_MESSAGING, data);
  },
  setVisitorTyping({ commit }, isTyping) {
    commit(SET_IS_VISITOR_TYPING, isTyping);
  },
};

export default actions;
